class ProductGlobalForm extends HTMLElement {
  constructor() {
    super();
    this.currentVariantId = null;
    this.productVariants = [];
  }

  connectedCallback() {
    this.addToCartBtn = this.querySelector(".add-to-cart");
    this.variantSelector = this.querySelector("variant-selector");
    this.productVariants = window.productVariants;
    this.fieldset = this.querySelectorAll("fieldset");
    // Set default variant
    this.currentVariantId = this.getSelectedVariantId();
    console.log(this.getSelectedVariantId());
    this.shopSymbol = this.getShopSymbol(this.getSelectedVariantId());

    this.initEvents();
    this.initVariantSelector();

    // Add to cart button event
    this.addToCartBtn.addEventListener("click", () => this.addToCart());
  }

  /* ----------------------------------
      VARIANT SELECTOR LOGIC MOVED HERE
  ---------------------------------- */
  initEvents() {
    const variantId = this.getSelectedVariantId();

    this.getVariantPrice(variantId);
    this.getVariantCompareAtPrice(variantId);
    this.calculateSavings(variantId);
    this.renderSavings(variantId);
    this.displayPriceAndComparePrice(variantId);
    this.renderSelectedValue();
  }
  initVariantSelector() {
    if (!this.variantSelector) return;

    const inputs = this.variantSelector.querySelectorAll("input[type='radio']");

    inputs.forEach((input) => {
      input.addEventListener("change", () => {
        // Update current variant
        const newVariantId = this.getSelectedVariantId();
        this.currentVariantId = newVariantId;

        // Update dependent option availability
        this.updateDependentOptions();

        // Update URL, price, savings, etc.
        this.updateURL(newVariantId);
        this.getVariantPrice(newVariantId);
        this.calculateSavings(newVariantId);
        this.displayPriceAndComparePrice(newVariantId);
        this.renderSavings(newVariantId);
        this.renderSelectedValue();
      });
    });

    // Initialize dependent options on load
    this.updateDependentOptions();
  }

  updateDependentOptions() {
    const optionDivs = Array.from(
      this.variantSelector.querySelectorAll(".product-form__option-values"),
    );
    if (!optionDivs.length) return;

    // Get current selections
    const selectedValues = optionDivs.map((div) => {
      const checked = div.querySelector("input[type='radio']:checked");
      return checked ? checked.value : null;
    });

    optionDivs.forEach((div, optionIndex) => {
      const inputs = Array.from(div.querySelectorAll("input[type='radio']"));

      inputs.forEach((input) => {
        // Build a "hypothetical selection" for this input
        const hypotheticalSelection = [...selectedValues];
        hypotheticalSelection[optionIndex] = input.value;

        // Check if a variant exists for this combination
        const isAvailable = this.productVariants.some(
          (v) =>
            v.available &&
            v.options.every(
              (opt, i) =>
                hypotheticalSelection[i] === null ||
                v.options[i] === hypotheticalSelection[i],
            ),
        );

        // Update input state and parent div
        input.disabled = !isAvailable;
        const parentDiv = input.closest(".product-form__option-value");
        if (isAvailable) {
          parentDiv.classList.remove("product-form__option-value--unavailable");
        } else {
          parentDiv.classList.add("product-form__option-value--unavailable");

          // Uncheck if it was previously selected
          if (input.checked) input.checked = false;
        }
      });

      // If no selected input in this option, auto-select first available
      const selectedInDiv = div.querySelector("input[type='radio']:checked");
      if (!selectedInDiv) {
        const firstAvailable = inputs.find((i) => !i.disabled);
        if (firstAvailable) firstAvailable.checked = true;
      }
    });
  }

  renderSelectedValue() {
    this.fieldset.forEach((fieldset) => {
      const legend = fieldset.querySelector(".product-form__selected-variant");
      const checkedInput = fieldset.querySelector(
        'input[type="radio"]:checked',
      );
      if (checkedInput && legend) legend.textContent = checkedInput.value;
    });
  }

  renderSavings(variantId) {
    const savingEl = document.querySelector(".details-form__saved");
    if (savingEl) {
      if (this.calculateSavings(variantId) != null) {
        savingEl.textContent = this.calculateSavings(variantId) + " OFF";
      } else {
        savingEl.remove();
      }
    }
  }

  displayPriceAndComparePrice(variantId) {
    const variant = this.productVariants.find((v) => v.id == variantId);

    const priceStr = variant.price;
    const compareStr = variant.compare_at_price;
    const priceEl = document.querySelector(".details-prices__price");
    const compareEl = document.querySelector(".details-prices__compare");
    if (priceEl && compareEl) {
      priceEl.textContent = priceStr;
      if (variant.raw_compare_at_price > variant.raw_price) {
        compareEl.textContent = compareStr;
      }
    }
  }

  getShopSymbol(variantId) {
    const variant = this.productVariants.find((v) => v.id == variantId);
    const symbol = variant.price.match(/^[^\d,]+/)[0];
    return variant ? symbol : null;
  }

  getVariantPrice(variantId) {
    const variant = this.productVariants.find((v) => v.id == variantId);
    const price = (variant.raw_price / 100).toFixed(2);
    return variant ? price : null;
  }
  getVariantCompareAtPrice(variantId) {
    const variant = this.productVariants.find((v) => v.id == variantId);
    const comparePrice = (variant.raw_compare_at_price / 100).toFixed(2);
    return variant ? comparePrice : null;
  }

  calculateSavings(variantId) {
    const price = this.getVariantPrice(variantId);
    const comparePrice = this.getVariantCompareAtPrice(variantId);

    const symbol = this.shopSymbol;

    let savings = comparePrice - price;
    let totalSaving = null;

    if (savings <= 0) {
      totalSaving = null;
    } else {
      totalSaving = `${symbol}${+savings.toFixed(2)}`;
    }
    return totalSaving;
  }

  getSelectedVariantId() {
    const optionDivs = this.querySelectorAll(".product-form__option-values");

    if (optionDivs.length === 0) {
      return (
        Number(this.dataset.defaultVariant) ||
        this.productVariants?.[0]?.id ||
        null
      );
    }

    const selectedOptions = [];
    optionDivs.forEach((optionDiv) => {
      const selectedInput = optionDiv.querySelector(
        "input[type='radio']:checked",
      );
      selectedOptions.push(selectedInput ? selectedInput.value : null);
    });

    const variant = this.productVariants.find((v) =>
      v.options.every((opt, i) => opt === selectedOptions[i]),
    );

    return variant ? variant.id : null;
  }

  updateURL(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variantId);
    window.history.replaceState({}, "", url.toString());
  }

  /* ----------------------------------
        ADD TO CART
  ---------------------------------- */
  addToCart() {
    const variantId = this.currentVariantId;

    // ✅ button loading text (same pattern as your async version)
    const btn = this.querySelector(".add-to-cart");
    const originalText = btn ? btn.textContent : null;

    if (btn) {
      btn.textContent = "Adding...";
      btn.disabled = true;
    }

    const payload = {
      items: [{ id: variantId, quantity: 1 }],
      sections: "el-custom-cart-drawer,el-header",
    };

    fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Add to cart failed");
        return res.json();
      })
      .then((data) => {
        // ✅ OPEN THE DRAWER on success
        const cartDrawer = document.querySelector("custom-cart-drawer");
        if (cartDrawer) cartDrawer.setAttribute("open", "");

        // ✅ rerender via sections
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:rerender", {
            detail: data,
            bubbles: true,
          }),
        );

        // ✅ keep old event if you still need it
        document.dispatchEvent(
          new CustomEvent("cart:updated", { detail: data }),
        );
      })
      .catch((err) => {
        console.error(err);
        alert("Failed to add item. Please try again.");
      })
      .finally(() => {
        // ✅ restore button state
        if (btn) {
          btn.textContent = originalText;
          btn.disabled = false;
        }
      });
  }
}

customElements.define("product-global-form", ProductGlobalForm);
